// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Popup/Popup.css */

.popup-overlay {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 10000;
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: calc(100vh - 40px);
    overflow-y: auto;
}

.popup-container {
    position: fixed;
    top: 100px;
    right: 20px;
    z-index: 10000;
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: 250px;
    max-height: 75vh;
    overflow-y: auto;
}

.popup-container::-webkit-scrollbar {
    width: 0;
}

.popup-message {
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    padding: 2px;
    cursor: pointer;
    position: relative;
    animation: slideIn 0.2s ease-out;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    text-align: left;
}

.popup-message:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.popup-message.high,
.popup-message.red {
    border-left: 4px solid #f44336;
    background-color: #ffcdd2;
}

.popup-message.medium,
.popup-message.orange {
    border-left: 4px solid #ff9800;
    background-color: #ffe0b2;
}

.popup-message.low,
.popup-message.green {
    border-left: 4px solid #4caf50;
    background-color: #c8e6c9;
}

.popup-content {
    margin-right: 24px; /* Space for close button */
}

.premium-notification {
    width: 330px;
    max-width: calc(100vw - 40px);
    padding: 14px;
    border: 1px solid rgba(226, 232, 240, 0.9);
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    box-shadow: 0 18px 45px rgba(15, 23, 42, 0.18);
    overflow: hidden;
}

.premium-notification::before {
    content: "";
    position: absolute;
    inset: 0 auto 0 0;
    width: 5px;
    background: #2563eb;
}

.premium-notification.task::before {
    background: linear-gradient(180deg, #2563eb, #14b8a6);
}

.premium-notification.reminder::before {
    background: linear-gradient(180deg, #f59e0b, #10b981);
}

.premium-notification.danger::before {
    background: linear-gradient(180deg, #dc2626, #f97316);
}

.premium-notification.approved::before {
    background: #16a34a;
}

.premium-notification.rejected::before {
    background: #dc2626;
}

.premium-popup-head {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-right: 20px;
}

.premium-popup-icon {
    width: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background: #eef6ff;
    border: 1px solid #dbeafe;
    flex: 0 0 auto;
}

.premium-popup-title {
    margin: 0;
    color: #0f172a;
    font-size: 14px;
    font-weight: 800;
    line-height: 1.2;
}

.premium-popup-kicker {
    color: #64748b;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
}

.premium-popup-message {
    margin: 10px 20px 0 48px;
    color: #334155;
    font-size: 12px;
    line-height: 1.45;
    white-space: pre-line;
    max-height: 96px;
    overflow: hidden;
}

.customer-details p {
    margin: 5px 0;
    font-size: 12px;
    color: #333;
}

.time-info {
    margin-top: 5px;
    border-top: 1px solid #eee;
}

.time-info p {
    margin: 5px 0;
    font-size: 12px;
    color: #666;
}

.close-button {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: none;
    background: #f0f0f0;
    color: #666;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

.close-button:hover {
    background: #e0e0e0;
    color: #333;
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

/* Responsive adjustments */
@media (max-width: 480px) {
    .popup-container {
        top: 10px;
        right: 10px;
        left: 10px;
        max-width: none;
    }

    .popup-message {
        padding: 8px;
    }

    .customer-details p,
    .time-info p {
        font-size: 13px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Other/Popup/Popup.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,WAAW;IACX,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gCAAgC;IAChC,qDAAqD;IACrD,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;;IAEI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;;IAEI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;;IAEI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB,EAAE,2BAA2B;AACnD;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,aAAa;IACb,0CAA0C;IAC1C,6DAA6D;IAC7D,8CAA8C;IAC9C,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA,2BAA2B;AAC3B;IACI;QACI,SAAS;QACT,WAAW;QACX,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;;QAEI,eAAe;IACnB;AACJ","sourcesContent":["/* src/components/routes/Popup/Popup.css */\n\n.popup-overlay {\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    z-index: 10000;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    max-height: calc(100vh - 40px);\n    overflow-y: auto;\n}\n\n.popup-container {\n    position: fixed;\n    top: 100px;\n    right: 20px;\n    z-index: 10000;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    max-width: 250px;\n    max-height: 75vh;\n    overflow-y: auto;\n}\n\n.popup-container::-webkit-scrollbar {\n    width: 0;\n}\n\n.popup-message {\n    background: white;\n    border-radius: 10px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    padding: 2px;\n    cursor: pointer;\n    position: relative;\n    animation: slideIn 0.2s ease-out;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    text-align: left;\n}\n\n.popup-message:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);\n}\n\n.popup-message.high,\n.popup-message.red {\n    border-left: 4px solid #f44336;\n    background-color: #ffcdd2;\n}\n\n.popup-message.medium,\n.popup-message.orange {\n    border-left: 4px solid #ff9800;\n    background-color: #ffe0b2;\n}\n\n.popup-message.low,\n.popup-message.green {\n    border-left: 4px solid #4caf50;\n    background-color: #c8e6c9;\n}\n\n.popup-content {\n    margin-right: 24px; /* Space for close button */\n}\n\n.premium-notification {\n    width: 330px;\n    max-width: calc(100vw - 40px);\n    padding: 14px;\n    border: 1px solid rgba(226, 232, 240, 0.9);\n    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n    box-shadow: 0 18px 45px rgba(15, 23, 42, 0.18);\n    overflow: hidden;\n}\n\n.premium-notification::before {\n    content: \"\";\n    position: absolute;\n    inset: 0 auto 0 0;\n    width: 5px;\n    background: #2563eb;\n}\n\n.premium-notification.task::before {\n    background: linear-gradient(180deg, #2563eb, #14b8a6);\n}\n\n.premium-notification.reminder::before {\n    background: linear-gradient(180deg, #f59e0b, #10b981);\n}\n\n.premium-notification.danger::before {\n    background: linear-gradient(180deg, #dc2626, #f97316);\n}\n\n.premium-notification.approved::before {\n    background: #16a34a;\n}\n\n.premium-notification.rejected::before {\n    background: #dc2626;\n}\n\n.premium-popup-head {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding-right: 20px;\n}\n\n.premium-popup-icon {\n    width: 38px;\n    height: 38px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 8px;\n    background: #eef6ff;\n    border: 1px solid #dbeafe;\n    flex: 0 0 auto;\n}\n\n.premium-popup-title {\n    margin: 0;\n    color: #0f172a;\n    font-size: 14px;\n    font-weight: 800;\n    line-height: 1.2;\n}\n\n.premium-popup-kicker {\n    color: #64748b;\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n}\n\n.premium-popup-message {\n    margin: 10px 20px 0 48px;\n    color: #334155;\n    font-size: 12px;\n    line-height: 1.45;\n    white-space: pre-line;\n    max-height: 96px;\n    overflow: hidden;\n}\n\n.customer-details p {\n    margin: 5px 0;\n    font-size: 12px;\n    color: #333;\n}\n\n.time-info {\n    margin-top: 5px;\n    border-top: 1px solid #eee;\n}\n\n.time-info p {\n    margin: 5px 0;\n    font-size: 12px;\n    color: #666;\n}\n\n.close-button {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    border: none;\n    background: #f0f0f0;\n    color: #666;\n    font-size: 18px;\n    line-height: 1;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n}\n\n.close-button:hover {\n    background: #e0e0e0;\n    color: #333;\n}\n\n@keyframes slideIn {\n    from {\n        transform: translateX(100%);\n        opacity: 0;\n    }\n    to {\n        transform: translateX(0);\n        opacity: 1;\n    }\n}\n\n/* Responsive adjustments */\n@media (max-width: 480px) {\n    .popup-container {\n        top: 10px;\n        right: 10px;\n        left: 10px;\n        max-width: none;\n    }\n\n    .popup-message {\n        padding: 8px;\n    }\n\n    .customer-details p,\n    .time-info p {\n        font-size: 13px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
